import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaArrowLeft, FaUsers, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styles from "./NinReg.module.css";
import Circle from "../../assets/Frame 155 circle.svg";
import OLogo from "../../assets/OGUN STATE LOGO 1 (1).png";
import House from "../../assets/household.png";
import Gov from "../../assets/government.png";
import Info from "../../assets/info-circle.png";
import Check from "../../assets/Icon.png"

const NinReg = () => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const handleContinue = () => {
    // if (selected === "household") {
    //   navigate("/household-registration");
    // } else if (selected === "government") {
    //   navigate("/government-registration");
    // }
    navigate("/registration");
  };

  const [nin, setNin] = useState("");
  const [error, setError] = useState("");

  const handleVerify = () => {
    if (nin.length !== 11) {
      setError("Enter 11 digits");
      return;
    }
    setError("");
    alert("NIN Verified (frontend demo)");
  };

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // numbers only
    setNin(value);

    if (value.length !== 11) {
      setError("Enter 11 digits");
    } else {
      setError("");
    }
  };

  return (
     <div className={styles.wrapper}>
      {/* <Row className="h-100"> */}

        {/* LEFT SECTION */}
          <div className={styles.leftSection}>
          <div className={styles.leftContent}>

            <div className={styles.logo}>
              <img src={OLogo} className={styles.logoImg} alt="logo" />
              <div className={styles.logoText}>
                <h6>OGUN STATE</h6>
                <p>Social Registry</p>
              </div>
            </div>

            <h2>
              Create your <span>account</span>
            </h2>

            <p className={styles.desc}>
              Register your household or create a staff account. It's free and
              takes about 5 minutes
            </p>

            <ul className={styles.list}>
              <li>Secure and confidential handling of your information</li>
              <li>Quick registration in under 5 minutes</li>
              <li>Simple step-by-step process</li>
              <li>Required for access to government support programs</li>
              <li>Option to save and continue later</li>
            </ul>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className={styles.rightSection}>
          <div className={styles.rightContent}>

            <div className={styles.back} onClick={() => navigate("/")}>
              <FaArrowLeft style={{marginRight: "10px"}} /> Back to Home
            </div>

            <p className={styles.textind} >
          STEP 1 OF 4
        </p>
            <h4 className={styles.regtext}>NIN Verification</h4>
            <p className={styles.sub}>
              Enter your 11-digit National Identification Number 
            </p>

            {/* NOTE */}
            <div className={styles.note}>
              <div className={styles.noteimg}>
                <img src={Info} alt="Circle" className={styles.infoIcon} />
              </div>
              <p>
                <strong>Note:</strong>Your NIN is used to verify your identity. Details fetched from the NIMC database cannot be edited here. Contact NIMC if your information is incorrect
              </p>
            </div>

              {/* Input Section */}
            <div className={styles.inputGroup}>
              <label>National Identification Number (NIN)</label>

              <div className={styles.inputRow}>
                <input
                  type="text"
                  value={nin}
                  onChange={handleChange}
                  maxLength={11}
                  placeholder="11234567899"
                />

          <button onClick={handleVerify}>Verify NIN</button>
        </div>

        {error && <p className={styles.error}>{error}</p>}
      </div>

        {/* Verified Box */}
      <div className={styles.successBox}>
        <div className={styles.successHeader}>
            <img src={Check} alt="success icon" className={styles.iconMark} />
          <p>NIN Verified Successfully</p>
        </div>

        <div className={styles.detailsGrid}>

        <div className={styles.firstdetails}>
          <div>
            <span>FIRST NAME</span>
            <p>Adunola</p>
          </div>


          <div>
            <span>MIDDLE NAME</span>
            <p>Blessing</p>
          </div>
          </div>

          <div className={styles.secondetails}>
          <div>
            <span>LAST NAME</span>
            <p>Adeyemi</p>
          </div>

          <div>
            <span>DATE OF BIRTH</span>
            <p>14 / 03 / 1992</p>
          </div>
          </div>

        </div>

        <div className={styles.bottomNote}>
          These details were fetched from the NIMC database and cannot be
          edited. If any information is incorrect, please contact NIMC before
          proceeding
        </div>
      </div>

            {/* <hr /> */}

            {/* FOOTER */}
            <div className={styles.footer}>
              <button className={styles.btnback}><span style={{marginRight: "5px"}}>← </span>Back</button>

              <span>1 of 4</span>

              <button
                className={styles.continueBtn}
                // disabled={!selected}
                disabled={!nin}
                onClick={handleContinue}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      {/* </Row> */}
    </div>
  );
};

export default NinReg;